import { isPropertyRateLoyaltyPackageUpgradeItem } from 'checkout/lib/utils/loyalty/propertyRateLoyaltyUpgrade'
import { getPackageUniqueKey } from 'lib/offer/offerUtils'

export default function getEffectiveLeHotelPackage(
  item: App.Checkout.InstantBookingLEHotelItem | App.Checkout.BNBLLEHotelItem,
  offer: App.Offer,
): App.Package | undefined {
  let pkgUniqueKey = getPackageUniqueKey(item.packageId, item.duration, item.roomRateId)

  if (item.loyaltyAppliedUpgradeType && !isPropertyRateLoyaltyPackageUpgradeItem(item)) {
    const originPackage = offer.packages.find(pkg => pkg.uniqueKey === pkgUniqueKey)
    const upgradeTargetPackageUniqueKey = originPackage?.loyalty.upgradeTargetsUniqueKeys?.[item.loyaltyAppliedUpgradeType]
    if (upgradeTargetPackageUniqueKey) {
      // @ts-expect-error string satisfies the magic string here
      pkgUniqueKey = upgradeTargetPackageUniqueKey
    }
  }

  return offer.packages.find(pkg => pkg.uniqueKey === pkgUniqueKey)
}
